import { Icon, IconProps } from "@chakra-ui/react";
import { FC } from "react";

export const PointIcon: FC<IconProps> = ({ ...props }) => (
  <Icon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 17.5C14.6421 17.5 18 14.1421 18 10C18 5.85786 14.6421 2.5 10.5 2.5C6.35786 2.5 3 5.85786 3 10C3 14.1421 6.35786 17.5 10.5 17.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.69385 10.8235H11.1938C11.6911 10.8235 12.168 10.6259 12.5197 10.2743C12.8713 9.92268 13.0688 9.44577 13.0688 8.94849C13.0688 8.45121 12.8713 7.97429 12.5197 7.62266C12.168 7.27103 11.6911 7.07349 11.1938 7.07349H8.69385V13.3235"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SelectedPointIcon: FC<IconProps> = ({ ...props }) => (
  <Icon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.19385 7.0736C8.19385 6.79746 8.41771 6.5736 8.69385 6.5736H11.1938C11.8237 6.5736 12.4278 6.82382 12.8732 7.26922C13.3186 7.71462 13.5688 8.31871 13.5688 8.9486C13.5688 9.57849 13.3186 10.1826 12.8732 10.628C12.4278 11.0734 11.8237 11.3236 11.1938 11.3236H9.19385V13.3236C9.19385 13.5997 8.96999 13.8236 8.69385 13.8236C8.41771 13.8236 8.19385 13.5997 8.19385 13.3236V7.0736ZM9.19385 10.3236H11.1938C11.5585 10.3236 11.9083 10.1787 12.1661 9.92087C12.424 9.66301 12.5688 9.31327 12.5688 8.9486C12.5688 8.58393 12.424 8.23419 12.1661 7.97633C11.9083 7.71847 11.5585 7.5736 11.1938 7.5736H9.19385V10.3236ZM2.5 10C2.5 5.58172 6.08172 2 10.5 2C14.9183 2 18.5 5.58172 18.5 10C18.5 14.4183 14.9183 18 10.5 18C6.08172 18 2.5 14.4183 2.5 10Z"
      fill="#85B656"
    />
  </Icon>
);

export const PostIcon: FC<IconProps> = (props) => (
  <Icon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 13.125V18.125"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 18.125H13"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 7.5V10.625"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0347 1.87514C15.7917 1.90171 18 4.81469 18 8.32974V11.7917C18 11.9795 17.9415 12.1597 17.8373 12.2925C17.7331 12.4254 17.5918 12.5 17.4444 12.5H8.55556M13 1.87503L8 1.87503M3 8.25006C2.99998 7.40916 3.13045 6.57656 3.3839 5.80022C3.63734 5.02388 4.00874 4.31914 4.47672 3.7266C4.9447 3.13405 5.5 2.6654 6.11064 2.34765C6.72128 2.0299 7.3752 1.86931 8.03472 1.87515C10.7917 1.90172 13 4.8147 13 8.32975V11.7917C13 11.9795 12.9415 12.1597 12.8373 12.2925C12.7331 12.4254 12.5918 12.5 12.4444 12.5H3.55556C3.40821 12.5 3.26691 12.4254 3.16272 12.2925C3.05853 12.1597 3 11.9795 3 11.7917L3 8.25006Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SelectedPostIcon: FC<IconProps> = (props) => (
  <Icon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 8.25006C2.99998 7.40916 3.13045 6.57656 3.3839 5.80022C3.63734 5.02388 4.00874 4.31914 4.47672 3.7266C4.9447 3.13405 5.5 2.6654 6.11064 2.34765C6.72128 2.0299 7.3752 1.86931 8.03472 1.87515C10.7917 1.90172 13 4.8147 13 8.32975V11.7917C13 11.9795 12.9415 12.1597 12.8373 12.2925C12.7331 12.4254 12.5918 12.5 12.4444 12.5H3.55556C3.40821 12.5 3.26691 12.4254 3.16272 12.2925C3.05853 12.1597 3 11.9795 3 11.7917L3 8.25006Z"
      fill="#85B656"
    />
    <path
      d="M10.5 13.125V18.125M8 18.125H13M15.5 7.5V10.625M13.0347 1.87514C15.7917 1.90171 18 4.81469 18 8.32974V11.7917C18 11.9795 17.9415 12.1597 17.8373 12.2925C17.7331 12.4254 17.5918 12.5 17.4444 12.5H8.55556M13 1.87503L8 1.87503M3 8.25006C2.99998 7.40916 3.13045 6.57656 3.3839 5.80022C3.63734 5.02388 4.00874 4.31914 4.47672 3.7266C4.9447 3.13405 5.5 2.6654 6.11064 2.34765C6.72128 2.0299 7.3752 1.86931 8.03472 1.87515C10.7917 1.90172 13 4.8147 13 8.32975V11.7917C13 11.9795 12.9415 12.1597 12.8373 12.2925C12.7331 12.4254 12.5918 12.5 12.4444 12.5H3.55556C3.40821 12.5 3.26691 12.4254 3.16272 12.2925C3.05853 12.1597 3 11.9795 3 11.7917L3 8.25006Z"
      stroke="#85B656"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const NotificationIcon: FC<IconProps> = (props) => (
  <Icon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.89062 8.12496C4.88958 7.38401 5.03514 6.65017 5.31892 5.96572C5.6027 5.28126 6.0191 4.65971 6.54412 4.13686C7.06914 3.61402 7.69242 3.20022 8.37805 2.91928C9.06368 2.63835 9.79812 2.49584 10.5391 2.49996C13.6328 2.5234 16.1094 5.09372 16.1094 8.19528V8.74996C16.1094 11.5468 16.6953 13.1718 17.2109 14.0625C17.2657 14.1573 17.2946 14.2649 17.2947 14.3744C17.2948 14.4839 17.2661 14.5916 17.2115 14.6865C17.1569 14.7815 17.0783 14.8604 16.9836 14.9154C16.8889 14.9704 16.7814 14.9996 16.6719 15H4.32812C4.2186 14.9996 4.1111 14.9704 4.01639 14.9154C3.92169 14.8604 3.8431 14.7815 3.78851 14.6865C3.73391 14.5916 3.70523 14.4839 3.70532 14.3744C3.70542 14.2649 3.7343 14.1573 3.78906 14.0625C4.30468 13.1718 4.89062 11.5468 4.89062 8.74996V8.12496Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 15V15.625C8 16.288 8.26339 16.9239 8.73223 17.3928C9.20107 17.8616 9.83696 18.125 10.5 18.125C11.163 18.125 11.7989 17.8616 12.2678 17.3928C12.7366 16.9239 13 16.288 13 15.625V15"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SelectedNotificationIcon: FC<IconProps> = (props) => (
  <Icon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.75 13.7422C17.2891 12.9453 16.7344 11.4297 16.7344 8.75V8.19531C16.7344 4.73438 13.961 1.89844 10.5469 1.875H10.5C9.68028 1.87603 8.86878 2.0385 8.11183 2.35315C7.35489 2.66779 6.66733 3.12845 6.08841 3.70882C5.5095 4.28918 5.05056 4.97789 4.73781 5.73562C4.42506 6.49335 4.26462 7.30526 4.26564 8.125V8.75C4.26564 11.4297 3.71096 12.9453 3.25002 13.7422C3.13854 13.9321 3.07921 14.1481 3.07802 14.3683C3.07683 14.5885 3.13383 14.8051 3.24325 14.9961C3.35267 15.1872 3.51063 15.346 3.70114 15.4565C3.89165 15.5669 4.10795 15.625 4.32814 15.625H7.37502C7.37502 16.4538 7.70426 17.2487 8.29031 17.8347C8.87636 18.4208 9.67122 18.75 10.5 18.75C11.3288 18.75 12.1237 18.4208 12.7097 17.8347C13.2958 17.2487 13.625 16.4538 13.625 15.625H16.6719C16.8921 15.6264 17.1086 15.5693 17.2994 15.4594C17.4903 15.3496 17.6484 15.1911 17.7578 15C17.8663 14.8079 17.9226 14.5907 17.9212 14.3701C17.9199 14.1494 17.8608 13.933 17.75 13.7422ZM10.5 17.5C10.0034 17.4979 9.52765 17.2997 9.17647 16.9486C8.82528 16.5974 8.62708 16.1216 8.62502 15.625H12.375C12.373 16.1216 12.1748 16.5974 11.8236 16.9486C11.4724 17.2997 10.9967 17.4979 10.5 17.5Z"
      fill="#85B656"
    />
  </Icon>
);

export const UserIcon: FC<IconProps> = (props) => (
  <Icon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.48438 15.5761C5.95516 14.6505 6.67291 13.8732 7.55815 13.3303C8.44339 12.7874 9.4616 12.5 10.5001 12.5C11.5385 12.5 12.5567 12.7874 13.442 13.3303C14.3272 13.8732 15.045 14.6505 15.5158 15.5761"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 17.5C14.6421 17.5 18 14.1421 18 10C18 5.85786 14.6421 2.5 10.5 2.5C6.35786 2.5 3 5.85786 3 10C3 14.1421 6.35786 17.5 10.5 17.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 12.5C12.2259 12.5 13.625 11.1009 13.625 9.375C13.625 7.64911 12.2259 6.25 10.5 6.25C8.77411 6.25 7.375 7.64911 7.375 9.375C7.375 11.1009 8.77411 12.5 10.5 12.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SelectedUserIcon: FC<IconProps> = (props) => (
  <Icon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 12.8125C12.3985 12.8125 13.9375 11.2735 13.9375 9.375C13.9375 7.47652 12.3985 5.9375 10.5 5.9375C8.60152 5.9375 7.0625 7.47652 7.0625 9.375C7.0625 11.2735 8.60152 12.8125 10.5 12.8125Z"
      fill="#85B656"
    />
    <path
      d="M10.5 1.875C8.89303 1.875 7.32214 2.35152 5.986 3.24431C4.64985 4.1371 3.60844 5.40605 2.99348 6.8907C2.37852 8.37535 2.21762 10.009 2.53112 11.5851C2.84463 13.1612 3.61846 14.6089 4.75476 15.7452C5.89106 16.8815 7.3388 17.6554 8.9149 17.9689C10.491 18.2824 12.1247 18.1215 13.6093 17.5065C15.094 16.8916 16.3629 15.8502 17.2557 14.514C18.1485 13.1779 18.625 11.607 18.625 10C18.6209 7.84638 17.7635 5.78216 16.2407 4.25932C14.7178 2.73648 12.6536 1.87913 10.5 1.875ZM15.6406 14.5625C15.1347 13.8368 14.4828 13.2247 13.7266 12.7656C12.8583 13.5974 11.7024 14.0618 10.5 14.0618C9.29762 14.0618 8.14168 13.5974 7.27344 12.7656C6.51725 13.2247 5.8653 13.8368 5.35938 14.5625C4.47952 13.5717 3.90473 12.3477 3.70419 11.0379C3.50365 9.7281 3.68591 8.38824 4.22903 7.17957C4.77214 5.97091 5.65298 4.94495 6.76553 4.22517C7.87807 3.50539 9.17492 3.12246 10.5 3.12246C11.8251 3.12246 13.1219 3.50539 14.2345 4.22517C15.347 4.94495 16.2279 5.97091 16.771 7.17957C17.3141 8.38824 17.4964 9.7281 17.2958 11.0379C17.0953 12.3477 16.5205 13.5717 15.6406 14.5625Z"
      fill="#85B656"
    />
  </Icon>
);

export const ChevronRightIcon: FC<IconProps> = (props) => (
  <Icon
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.5 0.75L6.75 7L0.5 13.25"
      stroke="#BDBDBD"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChevronDownIcon: FC<IconProps> = (props) => (
  <Icon
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.25 1L7 7.25L0.75 1"
      stroke="#BDBDBD"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PolygonIcon: FC<IconProps> = (props) => (
  <Icon
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 4.13397C8.66667 4.51887 8.66667 5.48113 8 5.86603L2 9.33013C1.33333 9.71503 0.5 9.2339 0.5 8.4641L0.5 1.5359C0.5 0.766098 1.33333 0.284973 2 0.669873L8 4.13397Z"
      fill="#85B656"
    />
  </Icon>
);

export const BadgeIcon: FC<IconProps> = (props) => (
  <Icon
    {...props}
    viewBox="0 0 11 11"
    fill="currentcolor"
    stroke="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="5.5" cy="5.5" r="5.5" fill="#F25E5E" />
  </Icon>
);

export const CheckCircleIcon: FC<IconProps> = (props) => (
  <Icon
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7105 7.41453C12.7628 7.46677 12.8043 7.52881 12.8326 7.5971C12.8609 7.66538 12.8754 7.73858 12.8754 7.8125C12.8754 7.88642 12.8609 7.95962 12.8326 8.0279C12.8043 8.09619 12.7628 8.15823 12.7105 8.21047L8.77297 12.148C8.72073 12.2003 8.65869 12.2418 8.59041 12.2701C8.52212 12.2984 8.44892 12.3129 8.375 12.3129C8.30108 12.3129 8.22789 12.2984 8.1596 12.2701C8.09131 12.2418 8.02928 12.2003 7.97703 12.148L6.28953 10.4605C6.18399 10.3549 6.12469 10.2118 6.12469 10.0625C6.12469 9.91323 6.18399 9.77008 6.28953 9.66453C6.39508 9.55898 6.53824 9.49969 6.6875 9.49969C6.83677 9.49969 6.97992 9.55898 7.08547 9.66453L8.375 10.9548L11.9145 7.41453C11.9668 7.36223 12.0288 7.32074 12.0971 7.29244C12.1654 7.26413 12.2386 7.24956 12.3125 7.24956C12.3864 7.24956 12.4596 7.26413 12.5279 7.29244C12.5962 7.32074 12.6582 7.36223 12.7105 7.41453ZM16.8125 9.5C16.8125 10.9463 16.3836 12.3601 15.5801 13.5626C14.7766 14.7651 13.6346 15.7024 12.2984 16.2559C10.9622 16.8093 9.49189 16.9541 8.07341 16.672C6.65492 16.3898 5.35196 15.6934 4.32928 14.6707C3.30661 13.648 2.61017 12.3451 2.32801 10.9266C2.04586 9.50811 2.19067 8.03781 2.74413 6.70163C3.2976 5.36544 4.23486 4.22339 5.4374 3.41988C6.63993 2.61637 8.05373 2.1875 9.5 2.1875C11.4388 2.18955 13.2975 2.96063 14.6685 4.33154C16.0394 5.70246 16.8105 7.56123 16.8125 9.5ZM15.6875 9.5C15.6875 8.27623 15.3246 7.07994 14.6447 6.06241C13.9648 5.04488 12.9985 4.25181 11.8679 3.7835C10.7372 3.31518 9.49314 3.19264 8.29288 3.43139C7.09262 3.67014 5.99012 4.25944 5.12478 5.12478C4.25944 5.99011 3.67014 7.09262 3.43139 8.29288C3.19265 9.49314 3.31518 10.7372 3.7835 11.8679C4.25182 12.9985 5.04488 13.9648 6.06241 14.6447C7.07994 15.3246 8.27623 15.6875 9.5 15.6875C11.1405 15.6856 12.7132 15.0331 13.8732 13.8732C15.0331 12.7132 15.6856 11.1405 15.6875 9.5Z"
        fill="currentColor"
      />
    </svg>
  </Icon>
);

export const XCircleIcon: FC<IconProps> = (props) => (
  <Icon
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.148 7.64797L10.2952 9.5L12.148 11.352C12.2002 11.4043 12.2417 11.4663 12.27 11.5346C12.2983 11.6029 12.3128 11.6761 12.3128 11.75C12.3128 11.8239 12.2983 11.8971 12.27 11.9654C12.2417 12.0337 12.2002 12.0957 12.148 12.148C12.0957 12.2002 12.0337 12.2417 11.9654 12.27C11.8971 12.2983 11.8239 12.3128 11.75 12.3128C11.6761 12.3128 11.6029 12.2983 11.5346 12.27C11.4663 12.2417 11.4043 12.2002 11.352 12.148L9.5 10.2952L7.64797 12.148C7.59571 12.2002 7.53367 12.2417 7.46538 12.27C7.3971 12.2983 7.32391 12.3128 7.25 12.3128C7.17609 12.3128 7.10291 12.2983 7.03462 12.27C6.96634 12.2417 6.9043 12.2002 6.85203 12.148C6.79977 12.0957 6.75832 12.0337 6.73003 11.9654C6.70175 11.8971 6.68719 11.8239 6.68719 11.75C6.68719 11.6761 6.70175 11.6029 6.73003 11.5346C6.75832 11.4663 6.79977 11.4043 6.85203 11.352L8.70477 9.5L6.85203 7.64797C6.74649 7.54242 6.68719 7.39927 6.68719 7.25C6.68719 7.10073 6.74649 6.95758 6.85203 6.85203C6.95758 6.74648 7.10074 6.68719 7.25 6.68719C7.39927 6.68719 7.54242 6.74648 7.64797 6.85203L9.5 8.70477L11.352 6.85203C11.4043 6.79977 11.4663 6.75831 11.5346 6.73003C11.6029 6.70174 11.6761 6.68719 11.75 6.68719C11.8239 6.68719 11.8971 6.70174 11.9654 6.73003C12.0337 6.75831 12.0957 6.79977 12.148 6.85203C12.2002 6.90429 12.2417 6.96634 12.27 7.03462C12.2983 7.1029 12.3128 7.17609 12.3128 7.25C12.3128 7.32391 12.2983 7.3971 12.27 7.46538C12.2417 7.53366 12.2002 7.59571 12.148 7.64797ZM16.8125 9.5C16.8125 10.9463 16.3836 12.3601 15.5801 13.5626C14.7766 14.7651 13.6346 15.7024 12.2984 16.2559C10.9622 16.8093 9.49189 16.9541 8.07341 16.672C6.65492 16.3898 5.35196 15.6934 4.32928 14.6707C3.30661 13.648 2.61017 12.3451 2.32801 10.9266C2.04586 9.50811 2.19067 8.03781 2.74413 6.70163C3.2976 5.36544 4.23486 4.22339 5.4374 3.41988C6.63993 2.61637 8.05373 2.1875 9.5 2.1875C11.4388 2.18955 13.2975 2.96063 14.6685 4.33154C16.0394 5.70246 16.8105 7.56123 16.8125 9.5ZM15.6875 9.5C15.6875 8.27623 15.3246 7.07994 14.6447 6.06241C13.9648 5.04488 12.9985 4.25181 11.8679 3.7835C10.7372 3.31518 9.49314 3.19264 8.29288 3.43139C7.09262 3.67014 5.99012 4.25944 5.12478 5.12478C4.25944 5.99011 3.67014 7.09262 3.43139 8.29288C3.19265 9.49314 3.31518 10.7372 3.7835 11.8679C4.25182 12.9985 5.04488 13.9648 6.06241 14.6447C7.07994 15.3246 8.27623 15.6875 9.5 15.6875C11.1405 15.6856 12.7132 15.0331 13.8732 13.8732C15.0331 12.7132 15.6856 11.1405 15.6875 9.5Z"
      fill="currentColor"
    />
  </Icon>
);

export const FavoriteOnIcon: FC<IconProps> = (props) => (
  <Icon
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="43" height="43" rx="21.5" fill="white" />
    <path
      d="M33 20.3125C33 26.875 23.2697 32.1869 22.8553 32.4062C22.7461 32.465 22.624 32.4958 22.5 32.4958C22.376 32.4958 22.2539 32.465 22.1447 32.4062C21.7303 32.1869 12 26.875 12 20.3125C12.0017 18.7715 12.6147 17.294 13.7044 16.2044C14.794 15.1147 16.2715 14.5017 17.8125 14.5C19.7484 14.5 21.4434 15.3325 22.5 16.7397C23.5566 15.3325 25.2516 14.5 27.1875 14.5C28.7285 14.5017 30.206 15.1147 31.2956 16.2044C32.3853 17.294 32.9983 18.7715 33 20.3125Z"
      fill="#B00E0E"
    />
    <rect
      x="1"
      y="1"
      width="43"
      height="43"
      rx="21.5"
      stroke="#B00E0E"
      strokeWidth="2"
    />
  </Icon>
);

export const FavoriteOffIcon: FC<IconProps> = (props) => (
  <Icon
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="43" height="43" rx="21.5" fill="white" />
    <path
      d="M27.1875 14.125C25.3041 14.125 23.6325 14.8684 22.5 16.1463C21.3675 14.8684 19.6959 14.125 17.8125 14.125C16.1721 14.127 14.5994 14.7795 13.4395 15.9395C12.2795 17.0994 11.627 18.6721 11.625 20.3125C11.625 27.0944 21.5447 32.5131 21.9666 32.7409C22.1305 32.8292 22.3138 32.8754 22.5 32.8754C22.6862 32.8754 22.8695 32.8292 23.0334 32.7409C23.4553 32.5131 33.375 27.0944 33.375 20.3125C33.373 18.6721 32.7205 17.0994 31.5605 15.9395C30.4006 14.7795 28.8279 14.127 27.1875 14.125ZM26.6728 27.4713C25.3671 28.5792 23.9714 29.5764 22.5 30.4525C21.0286 29.5764 19.6329 28.5792 18.3272 27.4713C16.2956 25.7284 13.875 23.0706 13.875 20.3125C13.875 19.2682 14.2898 18.2667 15.0283 17.5283C15.7667 16.7898 16.7682 16.375 17.8125 16.375C19.4812 16.375 20.8781 17.2563 21.4584 18.6756C21.5429 18.8825 21.6871 19.0596 21.8726 19.1842C22.0581 19.3089 22.2765 19.3755 22.5 19.3755C22.7235 19.3755 22.9419 19.3089 23.1274 19.1842C23.3129 19.0596 23.4571 18.8825 23.5416 18.6756C24.1219 17.2563 25.5188 16.375 27.1875 16.375C28.2318 16.375 29.2333 16.7898 29.9717 17.5283C30.7102 18.2667 31.125 19.2682 31.125 20.3125C31.125 23.0706 28.7044 25.7284 26.6728 27.4713Z"
      fill="#B00E0E"
    />
    <rect
      x="1"
      y="1"
      width="43"
      height="43"
      rx="21.5"
      stroke="#B00E0E"
      strokeWidth="2"
    />
  </Icon>
);
